export default "__VITE_ASSET__D9Gd1NWj__"